<!-- <ngx-loading-bar color="#007bff" height="3px"></ngx-loading-bar> -->
<router-outlet></router-outlet>
<app-notification></app-notification>

<!-- <app-loading></app-loading> -->
